/** When `'true'`, the tone-page plugin promo modal no longer intercepts downloads. */
export const PLUGIN_DOWNLOAD_MODAL_DISMISSED_KEY = 't3k_plugin_download_modal_dismissed';

export function hasDismissedPluginDownloadModal(): boolean {
  if (typeof window === 'undefined') return false;
  return localStorage.getItem(PLUGIN_DOWNLOAD_MODAL_DISMISSED_KEY) === 'true';
}

export function shouldShowPluginDownloadModal(): boolean {
  return !hasDismissedPluginDownloadModal();
}

export function dismissPluginDownloadModal() {
  if (typeof window === 'undefined') return;
  localStorage.setItem(PLUGIN_DOWNLOAD_MODAL_DISMISSED_KEY, 'true');
}
